<template>
  <div class="patient-list">
    <div class="patient-item font-85">
      <label>收货人</label>
      <input type="text" v-model="name" @blur="handleBlur" placeholder="请填写收货人姓名" />
    </div>
    <div class="patient-item font-85">
      <label>手机号码</label>
      <input type="text" v-model="phone" @blur="handleBlur" placeholder="请填写收货人手机号" />
    </div>
    <div class="patient-item font-85">
      <label>所在地区</label>
      <input
        class="address-input"
        type="text"
        v-model="addressText"
        @click="selectRegion"
        readonly
        placeholder="请选择地区"
      />
      <div class="is-link"></div>
    </div>
    <div class="patient-item font-85">
      <label>详细地址</label>
      <textarea
        type="text"
        @blur="handleBlur"
        v-model="xAddress"
        maxlength="500"
        :style="'height:'+textareaHeight"
        placeholder="如道路、小区、楼号、单元、门牌号等"
        ref="address"
        @input="textheight"
      ></textarea>
    </div>
    <div class="switch-box">
      <label>
        设为默认地址
        <span  class="address-span font-25">每次下单会默认选择该地址</span>
      </label>
      <el-switch v-model="swdefault" active-value="1" inactive-value="2"></el-switch>
    </div>
    <div class="switch-box red-font" @click="deleteAdd" v-if="id">删除收货地址</div>
    <button @click="handleSave" class="submit-btn" :class="{'del-btn':id}">保存</button>

    <div class="mask" v-show="maskshow">
      <div class="select-region">
        <div class="address-head font-85">
          配送至
          <span @click="maskshow=false">×</span>
        </div>
        <div class="address-center">
          <ul>
            <li :class="{active:provinceshow}" @click="provinceList">{{address.province.name}}</li>
            <li
              :class="{active:cityshow}"
              @click="provinceSelect(address.city.id,address.province.name)"
            >{{address.city.name}}</li>
            <li
              :class="{active:areashow}"
              @click="citySelect(address.city.id,'请选择')"
            >{{address.area.name}}</li>
          </ul>
        </div>
        <ul v-show="provinceshow">
          <li
            v-for="(item,index) in provinces"
            :key="index"
            @click="provinceSelect(item.id,item.region_name)"
            :class="{active:item.id == provinceac}"
          >{{item.region_name}}</li>
        </ul>
        <ul v-show="cityshow">
          <li
            v-for="(item,index) in citys"
            :key="index"
            @click="citySelect(item.id,item.region_name)"
            :class="{active:item.id == cityac}"
          >{{item.region_name}}</li>
        </ul>
        <ul v-show="areashow">
          <li
            v-for="(item,index) in areas"
            :key="index"
            @click="areaSelect(item.id,item.region_name)"
            :class="{active:item.id == areaac}"
          >{{item.region_name}}</li>
        </ul>
      </div>
    </div>
    <confirm
      v-if="is_confirm"
      confirm_txt="是否删除该收货地址？"
      success_txt="是"
      cancel_txt="否"
      @handleConfirm="handleConfirm"
    ></confirm>
  </div>
</template>

<script>
import http from "../../request/http";
import confirm from "../confirm";
export default {
  name: "address_edit",
  data() {
    return {
      provinces: [],
      citys: [],
      areas: [],
      name: "",
      phone: "",
      address: {
        province: {
          name: "请选择",
          id: "",
        },
        city: {
          name: "",
          id: "",
        },
        area: {
          name: "",
          id: "",
        },
      },
      addressText: "",
      xAddress: "",
      swdefault: 2,
      textareaHeight: "1.8rem",
      provinceshow: true,
      cityshow: false,
      areashow: false,
      maskshow: false,
      provinceac: 2,
      cityac: 0,
      areaac: 0,
      id: "",
      is_confirm: false,
      fun_timer:null
    };
  },
  components: {
    confirm,
  },
  created() {
    if (this.$route.query.id) {
      document.title = "编辑收货地址";
    } else {
      document.title = "新增收货地址";
    }
  },
  mounted() {
    this.provinceList();
    this.textheight();
    let id = this.$route.query.id;
    if (id) {
      this.id = id;
      http
        .post("/api/wap/user/consigneeinfo", {
          id: id,
        })
        .then((res) => {
          console.log(res);
          this.name = res.data.zname;
          this.phone = res.data.mobile;
          this.addressText =
            res.data.province_id +
            " " +
            res.data.city_id +
            " " +
            res.data.area_id;
          this.xAddress = res.data.address;
          this.swdefault = res.data.default;
          this.address.province.name = res.data.province_id
            ? res.data.province_id
            : "";
          this.address.province.id = res.data.province ? res.data.province : "";
          this.address.city.name = res.data.province_id ? res.data.city_id : "";
          this.address.city.id = res.data.province ? res.data.city : "";
          this.address.area.name = res.data.province_id ? res.data.area_id : "";
          this.address.area.id = res.data.province ? res.data.area : "";
        });
    }
  },
  methods: {
    handleBlur(){
      window.scrollTo(0,0)
    },
    //防抖
    debounce(fn, delay) {
      if (this.fun_timer) {
        clearTimeout(this.fun_timer);
      }
      this.fun_timer = setTimeout(fn, delay);
    },
    handleConfirm(val) {
      this.is_confirm = false;
      if (val) {
        http
          .post("/api/wap/user/consigneeedit", {
            id: this.id,
            zname: this.name,
            mobile: this.phone,
            province: this.address.province.id,
            city: this.address.city.id,
            area: this.address.area.id,
            address: this.xAddress,
            default: this.swdefault,
            addressinfo:this.addressText,
            status: 1,
          })
          .then((res) => {
            if (res.errno == 0) {
              this.$toast.center("删除成功");
              setTimeout(() => {
                if(this.$route.query.orderid){
                  this.$router.replace({name:"address_list",query:this.$route.query});
                }else{
                  this.$router.replace({name:"address_list"})
                }
              }, 300);
            } else {
              this.$toast.center(res.errmsg);
            }
          });
      }
    },
    selectRegion() {
      this.maskshow = true;
    },
    cityName() {
      this.addressText =
        this.address.province.name +
        " " +
        this.address.city.name +
        " " +
        this.address.area.name;
    },
    provinceList() {
      this.provinceshow = true;
      this.cityshow = false;
      this.areashow = false;
      this.addressText = "";
      this.address = {
        province: {
          name: "请选择",
          id: "",
        },
        city: {
          name: "",
          id: "",
        },
        area: {
          name: "",
          id: "",
        },
      };
      http
        .post("/api/wap/public/region", {
          id: 1,
        })
        .then((res) => {
          this.provinces = res.data;
        });
    },
    provinceSelect(id, name) {
      this.address.province.id = id;
      this.address.province.name = name;
      this.provinceac = id;
      this.provinceshow = false;
      this.cityshow = true;
      this.address.city.name = "请选择";
      this.address.area.name = "";
      this.cityName();
      http
        .post("/api/wap/public/region", {
          id: id,
        })
        .then((res) => {
          this.citys = res.data;
        });
    },
    citySelect(id, name) {
      this.address.city.id = id;
      this.address.city.name = name;
      this.address.area.name = "";
      this.cityac = id;
      this.cityshow = false;
      this.areashow = true;
      this.address.area.name = "请选择";
      this.cityName();
      http
        .post("/api/wap/public/region", {
          id: id,
        })
        .then((res) => {
          this.areas = res.data;
        });
    },
    areaSelect(id, name) {
      this.address.area.id = id;
      this.address.area.name = name;
      this.cityName();
      this.areaac = id;
      this.maskshow = false;
    },
    handleSave(){
      this.debounce(this.saveAddress,500)
    },
    saveAddress() {
      if (this.name == "") {
        this.$toast.center("请填写姓名");
      } else if (!this.address.province.name || !this.address.city.name || !this.address.area.name) {
        this.$toast.center("请选择所在地区");
      } else if (this.xAddress == "") {
        this.$toast.center("请输入详细地址");
      } else {
        http
          .post("/api/wap/user/consigneeedit", {
            id: this.id,
            zname: this.name,
            mobile: this.phone,
            province: this.address.province.id,
            city: this.address.city.id,
            area: this.address.area.id,
            address: this.xAddress,
            addressinfo:this.addressText,
            default: this.swdefault,
            status: 0,
          })
          .then((res) => {
            if (res.errno == 0) {
              this.$toast.center("保存成功");
              setTimeout(() => {
                if(this.$route.query.orderid){
                  this.$router.replace({name:"address_list",query:this.$route.query});
                }else{
                  this.$router.replace({name:"address_list"})
                }
              }, 300);
            } else {
              this.$toast.center(res.errmsg);
            }
          });
      }
    },
    deleteAdd() {
      this.is_confirm = true;
    },
    textheight() {
      console.log(this.$refs.address.scrollHeight);
      this.textareaHeight = this.$refs.address.scrollHeight + "px";
    },
  },
  destroyed(){
    if(this.fun_timer){
      clearTimeout(this.fun_timer);
      this.fun_timer = null;
    }
  }
};
</script>

<style scoped>
  body{
    overflow: auto;
  }
.red-font {
  color: #fa541c;
}
.patient-list {
  background: #fafafa;
  height: 100vh;
  margin: 0;
}
.address-input {
  text-align: right;
}
.is-link {
  width: 0.5rem;
  height: 0.5rem;
  border-top: 0.05rem solid rgba(0, 0, 0, 0.4);
  border-right: 0.05rem solid rgba(0, 0, 0, 0.4);
  transform: rotate(45deg);
  margin-left: 0.4rem;
}
.patient-list input{
  color:rgba(0, 0, 0, 0.65)
}
.submit-btn.del-btn{
  margin-top: 4.55rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/address/address_edit.vue